module.exports = __webpack_public_path__ + "static/media/hollow_bar_postlapSMAP_tall.746d7036.svg";